import { ITransaction } from './transaction';
export enum ImportTypeEnum {
  CashApp = 'CashApp',
  PayPal = 'PayPal',
  Other = 'Other',
  // QuickBooks = 'QuickBooks',
}

export interface ImportFormatResult {
  fields: string[];
  records: ITransaction[];
}
